import { semanticTypeRuntimePath } from 'Automations/nodeDefinitions/conditions/helpers/functionStrings'
import type { SemanticType } from 'Automations/nodeDefinitions/semanticTypes'

/**
 * Returns the subset of a switch's input mapping that the generated runtime
 * expression actually references. The full mapping is built up front so any
 * operator factory can reach for any upstream value, but the Conductor task
 * only needs to publish the keys whose bracket form (e.g.
 * `$["sequence.quote.currency"]`) appears in the expression.
 *
 * Bracket-form matching means a parent semantic type (e.g. `sequence.quote`)
 * isn't kept as a false positive for a child reference (e.g.
 * `$["sequence.quote.currency"]`) — the closing `"]` differs, so the parent's
 * literal substring is absent.
 */
export const pruneUnusedInputs = ({
  inputMapping,
  expression
}: {
  inputMapping: Record<string, string>
  expression: string
}): Record<string, string> =>
  Object.fromEntries(
    Object.entries(inputMapping).filter(([semanticType]) =>
      expression.includes(semanticTypeRuntimePath(semanticType as SemanticType))
    )
  )
